import { render, staticRenderFns } from "./remarkProcess.vue?vue&type=template&id=007314ae&scoped=true"
import script from "./remarkProcess.vue?vue&type=script&lang=js"
export * from "./remarkProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007314ae",
  null
  
)

export default component.exports